import { BRAND } from "../../data";

export const Marquee = () => {
  const phrase = "L'excellence à chaque trajet";
  const items = Array.from({ length: 6 });
  return (
    <section data-testid="marquee" className="py-10 border-y border-white/10 overflow-hidden bg-[#060B14]">
      <div className="marquee-track">
        {[0, 1].map((g) => (
          <div key={g} className="flex items-center">
            {items.map((_, i) => (
              <span key={`${g}-${i}`} className="font-serif italic text-stroke text-5xl sm:text-7xl lg:text-8xl px-8 flex items-center gap-8">
                {phrase}
                <span className="text-champagne not-italic text-2xl">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
};
